
import Vue from 'vue'
import { VIcon, VListItem, VListItemTitle } from 'vuetify/lib'
import { navList } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouterLinkMobile',
  components: {
    VListItem,
    VIcon,
    VListItemTitle,
  },
  props: {
    item: { type: Object as () => navList, required: true },
    menuLevel: { type: Number, default: 0 },
    isActive: { type: Boolean, default: false },
    groupItem: { type: Boolean, default: false },
  },
  data() {
    return {
      storybook: process.env.NODE_ENV == 'storybook',
    }
  },
})
